import { render, staticRenderFns } from "./addTestPaper.vue?vue&type=template&id=879f88e2"
import script from "./addTestPaper.vue?vue&type=script&lang=js"
export * from "./addTestPaper.vue?vue&type=script&lang=js"
import style0 from "./addTestPaper.vue?vue&type=style&index=0&id=879f88e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports